import React from 'react';

import { Box, Checkbox, Separator, Text } from '@betterment/samba-react';

import { PerformanceAccountsQuery } from '../../../../graphql/performanceAccounts.generated';

type HeaderProps = {
  header: string;
};

const Header = ({ header }: HeaderProps) => {
  return (
    <Box css={{ mb: 'space.200' }}>
      <Text variant="text100" css={{ mb: 'space.200', color: 'primitives.grey.70', fontSize: 'fontSize.70' }}>
        {header}
      </Text>
    </Box>
  );
};

type SectionProps = {
  showSeparator?: boolean;
  accounts: PerformanceAccountsQuery['performance']['accounts'];
  selectedAccountIds: Set<string>;
  toggleAccountSelection: (accountId: string) => void;
  header: string;
};

type SelectionRowProps = {
  isSelected: boolean;
  toggleSelection: (accountId: string) => void;
  label: string;
  accountId: string;
};

const SelectionRow = ({ isSelected, toggleSelection, label, accountId }: SelectionRowProps) => {
  const id = `${accountId}-selection-row`;
  return (
    <Box>
      <Checkbox css={{ mb: 'space.200' }} id={id}>
        <Checkbox.Label>{label}</Checkbox.Label>
        <Checkbox.Control
          appearance="default"
          checked={isSelected}
          onCheckedChange={() => toggleSelection(accountId)}
          aria-labelledby={id}
        />
      </Checkbox>
    </Box>
  );
};

export const Section = ({
  header,
  accounts,
  showSeparator = true,
  selectedAccountIds,
  toggleAccountSelection,
}: React.PropsWithChildren<SectionProps>) => {
  return (
    <Box css={{ mt: showSeparator ? 'space.200' : 'space.0' }}>
      {showSeparator && <Separator css={{ mb: 'space.200' }} />}
      <Header header={header} />
      {accounts.map(accountData => {
        const { id, name, envelope } = accountData;
        const purpose = envelope?.purpose;
        const displayName = purpose?.name ? purpose.name : name;
        return (
          <SelectionRow
            key={id}
            accountId={id}
            label={displayName}
            isSelected={selectedAccountIds.has(id)}
            toggleSelection={toggleAccountSelection}
          />
        );
      })}
    </Box>
  );
};
